import type { IconData } from '@stacksjs/iconify-core'

export const inboxes: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.961V18h16V4.961L14.298 2H5.702zM0 4l5-4h10l5 4v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm13.874 2a4.002 4.002 0 0 1-7.748 0H2V4h16v2zm-2.142 0H8.268a2 2 0 0 0 3.464 0m2.142 7a4.002 4.002 0 0 1-7.748 0H2v-2h16v2zm-2.142 0H8.268a2 2 0 0 0 3.464 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default inboxes
